export default __webpack_public_path__ + "static/media/FruttiDino.0d636b72.png";